import React from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { PageHeader, ResponsiveTable, TableSkeleton, EmptyState, DateCell, CopyId } from "@/admin/ui";

export default function AdminConsents() {
  const { t } = useLang();
  const [items, setItems] = React.useState(null);
  React.useEffect(() => { api.get("/api/admin/consents").then((r) => setItems(r.data.items)); }, []);

  return (
    <div className="space-y-6" data-testid="admin-consents-page">
      <PageHeader title={t("admin.consents.title")} description={t("admin.consents.subtitle")} />
      {!items ? <TableSkeleton rows={6} cols={7} /> : items.length === 0 ? (
        <EmptyState title="No consent records yet" />
      ) : (
        <ResponsiveTable minWidth={900}>
          <thead className="lp-table-sticky"><tr>
            <th>{t("admin.consents.col.user")}</th>
            <th>{t("admin.consents.col.doc")}</th>
            <th>{t("admin.consents.col.version")}</th>
            <th>{t("admin.consents.col.lang")}</th>
            <th>{t("admin.consents.col.context")}</th>
            <th>{t("admin.consents.col.ip")}</th>
            <th>{t("admin.consents.col.at")}</th>
          </tr></thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} data-testid={`consent-${c.id}`}>
                <td className="text-white/80 text-xs">{c.user?.email || <CopyId id={c.user_id} />}</td>
                <td className="text-white/70 text-xs">{c.doc_slug}</td>
                <td className="font-mono text-xs text-white/60">v{c.doc_version}</td>
                <td className="text-white/60 uppercase text-xs">{c.language}</td>
                <td className="text-white/60 text-xs">{c.context}</td>
                <td className="text-white/50 font-mono text-xs">{c.ip_address}</td>
                <td><DateCell value={c.accepted_at} /></td>
              </tr>
            ))}
          </tbody>
        </ResponsiveTable>
      )}
    </div>
  );
}
